import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Paragraph from "@/views/blocks/shared/section/typography/paragraph/Paragraph.vue";

interface StatProps {
    stat: string;
    title: string;
    description: string;
    backgroundColor: string;
    titleTextColor: string;
    descriptionTextColor: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Stat',
  props: {
    stat: {},
    title: {},
    description: {},
    backgroundColor: {},
    titleTextColor: {},
    descriptionTextColor: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex flex-col-reverse gap-8 justify-between lg:flex-col lg:items-start p-8 rounded-lg sm:items-end sm:flex-row-reverse",
    style: _normalizeStyle({ backgroundColor: _ctx.backgroundColor })
  }, [
    _createVNode(Paragraph, {
      text: _ctx.stat,
      class: "text-3xl font-bold",
      textColor: _ctx.titleTextColor
    }, null, 8, ["text", "textColor"]),
    _createElementVNode("div", null, [
      _createVNode(Paragraph, {
        text: _ctx.title,
        class: "text-lg font-semibold mb-2",
        textColor: _ctx.titleTextColor
      }, null, 8, ["text", "textColor"]),
      _createVNode(Paragraph, {
        text: _ctx.description,
        class: "text-base/7",
        textColor: _ctx.descriptionTextColor
      }, null, 8, ["text", "textColor"])
    ])
  ], 4))
}
}

})